export const DEMAND_URL = '/application-form/';
